import {
  Error as ErrorIcon,
  Refresh as RefreshIcon
} from "@mui/icons-material";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bankingService } from "../../services/bankingService";
import { t } from "../../translations";
import { createLogger } from "../../utils/logger";
import { openNotificationWithIcon } from "./notification-bar";

const logger = createLogger("StripeBankingRefresh");

const StripeBankingRefresh = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const lang = useSelector((state) => state.lang);

  useEffect(() => {
    refreshOnboarding();
  }, []);

  const refreshOnboarding = async () => {
    try {
      const response = await bankingService.startOnboarding(
        user._id,
        user.refresh_token
      );
      window.location.href = response.accountLink;
    } catch (error) {
      logger.error("Failed to refresh onboarding:", error);
      setError(
        error?.response?.data?.message ||
          t("errors.failed_to_refresh_onboarding", lang)
      );
      openNotificationWithIcon(
        "error",
        t("errors.failed_to_refresh_onboarding", lang)
      );
      setLoading(false);
    }
  };

  const handleRetry = () => {
    setLoading(true);
    setError(null);
    refreshOnboarding();
  };

  const handleReturn = () => {
    history.push("/chef/iam-a-chef/banking");
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        textAlign="center"
        p={4}
      >
        <CircularProgress size={60} sx={{ mb: 3 }} />
        <Typography variant="h6">
          {t("banking.refreshing_link", lang)}
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        textAlign="center"
        p={4}
      >
        <ErrorIcon color="error" sx={{ fontSize: 80, mb: 3 }} />

        <Typography variant="h4" gutterBottom>
          {t("banking.refresh_error_title", lang)}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {error}
        </Typography>

        <Box display="flex" gap={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleRetry}
            startIcon={<RefreshIcon />}
          >
            {t("banking.try_again", lang)}
          </Button>

          <Button variant="outlined" onClick={handleReturn}>
            {t("banking.return_to_dashboard", lang)}
          </Button>
        </Box>
      </Box>
    );
  }

  return null;
};

export default StripeBankingRefresh;
